/**
 * User preferences types
 * Note: Storage configuration removed - managed by backend only
 */

export interface UserPreferences {
  // Display preferences
  theme: 'light' | 'dark' | 'system';
  fontSize: 'small' | 'medium' | 'large';
  messageGrouping: boolean;
  showTimestamps: boolean;
  compactMode: boolean;
  showTokenUsage: boolean;  // NEW: Show token usage statistics

  // Chat behavior
  sendOnEnter: boolean;
  showTypingIndicator: boolean;
  enableSounds: boolean;
  autoSaveConversations: boolean;
  // Keep uploaded files attached after sending so they carry into the next
  // message. Off by default: the attachment is cleared once sent so it isn't
  // silently reused on a later turn.
  keepFilesAcrossMessages: boolean;

  // AI settings
  temperature: number;
  maxTokens: number;
  enableCitations: boolean;
  enableFileUpload: boolean;

  // Privacy
  saveHistory: boolean;
  shareAnalytics: boolean;

  // Conversation history
  conversationFilter: 'current-agent' | 'all-agents';

  // Accessibility
  highContrast: boolean;
  reducedMotion: boolean;
  screenReaderOptimized: boolean;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  // Display
  theme: 'system',
  fontSize: 'medium',
  messageGrouping: true,
  showTimestamps: true,
  compactMode: false,
  showTokenUsage: false,  // NEW: Hidden by default

  // Chat behavior
  sendOnEnter: true,
  showTypingIndicator: true,
  enableSounds: false,
  autoSaveConversations: true,
  keepFilesAcrossMessages: false,

  // AI settings
  temperature: 0.7,
  maxTokens: 4000,  // Increased from 1000 for longer responses
  enableCitations: true,
  enableFileUpload: true,

  // Privacy
  saveHistory: true,
  shareAnalytics: false,

  // Conversation history
  conversationFilter: 'current-agent',

  // Accessibility
  highContrast: false,
  reducedMotion: false,
  screenReaderOptimized: false,
};

export interface PreferencesContextType {
  preferences: UserPreferences;
  updatePreferences: (updates: Partial<UserPreferences>) => Promise<void>;
  resetPreferences: () => Promise<void>;
  exportPreferences: () => string;
  importPreferences: (data: string) => void;
  canOverride: (key: keyof UserPreferences) => boolean;
  isLoading: boolean;
}
